export default __webpack_public_path__ + "static/media/helper.35141a1c.jpg";